import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Menu } from 'antd';
import UserRoleType from "../../../routes/app/enums/UserRoleType";
import { UserOutlined } from "@ant-design/icons";
import { useAppDispatch, useAppSelector } from "../../../store";
import { changeDoLogout, loggedInUserSelector } from "../../../store/slice/auth";
import { watchGettingStartedIntro } from "../../../store/slice/settings";
const HeaderRight = () => {
    const dispatch = useAppDispatch();
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const userFullName = () => {
        if (loggedInUser) {
            return loggedInUser.firstName + " " + (loggedInUser.lastName ?? '');
        }
        return "";
    };
    const onLogout = (event) => {
        event.preventDefault();
        dispatch(changeDoLogout(true));
    };
    const onWatchGettingStartedIntro = (event) => {
        event.preventDefault();
        dispatch(watchGettingStartedIntro(true));
    };
    const roleEnum = loggedInUser && loggedInUser.roles && loggedInUser.roles.length && UserRoleType.valueOf(loggedInUser.roles[0]);
    const userHasGettingStartedIntro = roleEnum ? roleEnum.gettingStartedIntroKey : null;
    const subMenuItems = [];
    if (userHasGettingStartedIntro || true) {
        subMenuItems.push({
            key: 'getting-started-intro',
            label: _jsx("a", { href: "#", onClick: onWatchGettingStartedIntro, children: "Watch Intro" }),
        });
    }
    subMenuItems.push({
        key: 'change-password',
        label: _jsx("a", { href: "#/app/security/change-password", children: "Change Password" })
    }, {
        key: 'multi-factor-auth',
        label: _jsx("a", { href: "#/multi-factor/edit", children: "Multi-factor Authentication" })
    }, {
        key: 'pass-keys',
        label: _jsx("a", { href: "#/app/security/passkeys", children: "Passkeys" })
    }, {
        type: 'divider'
    }, {
        key: 'logout',
        label: _jsx("a", { href: "#", onClick: onLogout, children: "Logout" })
    });
    const menuItems = [{
            key: 'user-menu',
            label: _jsxs("span", { className: "user-menu-label", children: [_jsx(UserOutlined, {}), " ", userFullName()] }),
            children: subMenuItems
        }];
    return (_jsx(Menu, { className: "user-menu", mode: "horizontal", theme: "dark", disabledOverflow: true, items: menuItems }));
};
export default HeaderRight;
